import axios from 'axios';
import { mutate } from 'swr';
import { Notistack } from '@shared/components/Notistack/Notistack';
import { SERVICES } from '@shared/constants/apiConfig';
import { getError } from '@shared/utils/helpers';
import { IChargeBack } from './interfaces';

interface IUpdateUserRequest {
    paySystemUserId: string;
    payPlanType: string;
}

export const requestUpdateUser = (userId: string, userData: IUpdateUserRequest) => {
    const url = `${SERVICES.USER}/users/plan/${userId}`;
    return mutate(url, async() => {
      try {
        await axios.put(url, userData);
        Notistack.successMessage('User updated successfully');
      } catch (err) {
        Notistack.generalError(getError(err));
      }
    });
  };

export const requestUpdateChargeBacks = (periodId: string, chargeBackItems: IChargeBack[]) => {
  const url = `${SERVICES.USER}/users/chargebacks/upsert`;
  const body = {
    periodId,
    chargeBackItems
  };

  return mutate(url, async() => {
    try {
      await axios.put(url, body);
      Notistack.successMessage('Charge backs updated successfully');
    } catch (err) {
      Notistack.generalError(getError(err));
    }
  });
};